// extracted by mini-css-extract-plugin
export default {"button":"button--ojk4H","adjustment":"adjustment--rFzlu","fadeSlideUp":"fadeSlideUp--XKdhq"};